window.makeGalleryDraggable = function(className) {
    const element = document.querySelector('.' + className);
    if (!element) return; // Exit if the element doesn't exist

    element.style.transition = 'opacity 1s ease-out';
    const maxOverscroll = 200; // Maximum pixels you can overscroll past the gallery edges

    // Function to artificially extend the scrollable area
    const extendScrollableArea = () => {
        const createSpacerFigure = () => {
            const figure = document.createElement('figure');
            figure.className = 'wp-block-image size-large';
            figure.style.maxWidth = '10vw'; // Ensure spacer figure size matches your requirement
            return figure;
        };

        // Insert spacers at the beginning and end of the gallery
        element.prepend(createSpacerFigure());
        element.appendChild(createSpacerFigure());
    };

    // Apply the extension before centering the gallery
    extendScrollableArea();

    // Function to center and fade in the gallery
    const centerGallery = () => {
        const galleryWidth = element.scrollWidth;
        const containerWidth = element.offsetWidth;
        element.scrollLeft = (galleryWidth - containerWidth) / 2;
        element.style.opacity = 1;
    };

    // Center gallery after images have loaded
    window.onload = centerGallery;

    element.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - element.offsetLeft;
        scrollLeft = element.scrollLeft;
        element.style.scrollBehavior = 'auto'; // Disable smooth scrolling on drag
    });

    element.addEventListener('mouseleave', () => {
        isDown = false;
    });

    element.addEventListener('mouseup', () => {
        isDown = false;
        element.style.scrollBehavior = 'smooth'; // Re-enable smooth scrolling

        // Calculate the rebound scroll position
        const firstFigureWidth = element.firstChild.offsetWidth;
        const lastFigureWidth = element.lastChild.offsetWidth;
        
        if (element.scrollLeft < firstFigureWidth - maxOverscroll) {
            smoothScrollTo(element, firstFigureWidth, 500); // Adjust duration as needed
        } else if (element.scrollLeft + element.clientWidth > element.scrollWidth - lastFigureWidth + maxOverscroll) {
            smoothScrollTo(element, element.scrollWidth - element.clientWidth - lastFigureWidth, 500); // Adjust duration as needed
        }
    });

    element.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - element.offsetLeft;
        const walk = x - startX;
        let newScrollPosition = scrollLeft - walk;

        // Implementing elastic effect for overscroll
        if (newScrollPosition < 0) {
            newScrollPosition = Math.max(newScrollPosition, -maxOverscroll);
        } else if (newScrollPosition > element.scrollWidth - element.clientWidth) {
            newScrollPosition = Math.min(newScrollPosition, element.scrollWidth - element.clientWidth + maxOverscroll);
        }

        element.scrollLeft = newScrollPosition;
    });

    // Initialize Intersection Observer for additional functionality
    // ... Your existing Intersection Observer code remains unchanged
};

document.dispatchEvent(new CustomEvent('galleryScriptReady'));

function smoothScrollTo(element, target, duration) {
    const start = element.scrollLeft;
    const change = target - start;
    const startTime = performance.now();

    function animateScroll(timestamp) {
        const timeElapsed = timestamp - startTime;
        let progress = timeElapsed / duration;
        progress = -0.5 * (Math.cos(Math.PI * progress) - 1);

        element.scrollLeft = start + change * progress;

        if (timeElapsed < duration) {
            requestAnimationFrame(animateScroll);
        } else {
            element.style.scrollBehavior = 'smooth'; // Ensure smooth scroll is enabled after animation
        }
    }

    requestAnimationFrame(animateScroll);
}
